module.exports = __webpack_public_path__ + "img/circle-2.71362d6.png";